import { DEFAULT_PAGE_SIZE } from '@/components';
import { useDebouncedQueryStates } from '@/lib/nuqs';
import { parseAsInteger, parseAsString } from 'nuqs';

export const useOrganizationTemplatePageSearchQueryStates = () => {
  const queryStates = useDebouncedQueryStates({
    keyMap: {
      page: parseAsInteger.withDefault(1),
      pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
      cascader: parseAsString,
      q: parseAsString,
    },
  });
  return queryStates;
};
